import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import styles from './TooltipItem.scss';

export default class TooltipItem extends Component {
  state = {
    tooltipOpen: false
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  render() {
    return (
      <span className={styles.wrapper} id={this.props.target}>
        <i className='fa fa-question-circle'></i>
        <Tooltip
          placement={this.props.placement}
          isOpen={this.state.tooltipOpen}
          target={this.props.target}
          container={this.props.target}
          toggle={this.toggle}
        >
          {this.props.children}
        </Tooltip>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/TooltipItem.jsx